import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './Services/auth.service';
import { Global } from './Shared/global';

@Component({
  selector: 'app-restricted-access',
  template: `
    <div class="restricted-container">
      <div class="restricted-card">
        <div class="restricted-icon">
          <mat-icon>block</mat-icon>
        </div>
        <h1>Access Denied</h1>
        <p class="restricted-message">
          You don't have permission to access this resource.
        </p>
        <p class="restricted-instruction">
          If you believe this is an error, please contact your administrator.
        </p>
        <div class="restricted-actions">
          <button class="btn btn-primary" (click)="goToDashboard()">
            <mat-icon>home</mat-icon>
            Go to Dashboard
          </button>
          <button class="btn btn-secondary" (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            Logout
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .restricted-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
      padding: 20px;
    }

    .restricted-card {
      background: white;
      border-radius: 10px;
      padding: 60px 40px;
      text-align: center;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
      max-width: 500px;
    }

    .restricted-icon {
      color: #dc3545;
      margin-bottom: 20px;
    }

    .restricted-icon mat-icon {
      font-size: 80px;
      width: 80px;
      height: 80px;
    }

    h1 {
      color: #333;
      margin: 20px 0 10px 0;
      font-size: 28px;
    }

    .restricted-message {
      color: #666;
      font-size: 16px;
      margin: 15px 0;
    }

    .restricted-instruction {
      color: #999;
      font-size: 14px;
      margin-bottom: 30px;
    }

    .restricted-actions {
      display: flex;
      gap: 12px;
      justify-content: center;
      flex-wrap: wrap;
    }

    .btn {
      padding: 10px 20px;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }

    .btn-primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }

    .btn-primary:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
    }

    .btn-secondary {
      background: white;
      color: #667eea;
      border: 2px solid #667eea;
    }

    .btn-secondary:hover {
      background: #f0f4ff;
    }

    .btn mat-icon {
      font-size: 18px;
      width: 18px;
      height: 18px;
    }
  `]
})
export class RestrictedAccessComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Navigate to dashboard
   */
  goToDashboard(): void {
    this.router.navigate([Global.DefaultPage]);
  }

  /**
   * Logout user
   */
  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (error) => {
        Global.LogError('Logout error:', error);
        this.router.navigate(['/login']);
      }
    });
  }
}
